import React from 'react';
import './Skill.css'
import { FaCamera, FaEdit, FaHornbill, FaShoppingBag } from 'react-icons/fa';

const Skill = () => {
     return (
          <div id='skill'>

               <div class="bg-gradient-to-br from-purple-900 to-green-900  py-16 overflow-auto">
                    <div class="container max-w-5xl mx-auto px-4">
                         <div class="text-white relative">
                              <h1 class="mt-5 text-white text-3xl md:text-4xl mb-10 font-bold">My<span class="text-blue-200"> Expertise </span></h1>
                              <ul className='skill'>
                                   <li data-aos="flip-right" data-aos-duration='1000' style={{ backgroundColor: "#0B374D" }}>
                                        <div class="icon"><FaCamera></FaCamera></div>
                                        <div class="title">Photography</div>
                                        
                                   </li>
                                   <li data-aos="flip-right" data-aos-duration='1000' style={{ backgroundColor: "#1286A8" }}>
                                        <div class="icon"><FaShoppingBag></FaShoppingBag></div>
                                        <div class="title">Digital Marketing</div>
                                         
                                   </li>
                                   <li data-aos="flip-right" data-aos-duration='1000' style={{ backgroundColor: "#D2B53B" }}>
                                        <div class="icon"><FaHornbill></FaHornbill> </div>
                                        <div class="title">Graphics Design</div>
                                         
                                   </li>
                                   <li data-aos="flip-right" data-aos-duration='1000' style={{ backgroundColor: "#DA611E" }}>
                                        <div class="icon"><FaEdit></FaEdit></div>
                                        <div class="title">Video Editing</div>
                                         
                                   </li>

                              </ul>
                         </div>
                    </div>
               </div>
          </div>
     );
};

export default Skill;